/**
 * Generic utility to be used when you need to generate unique default names that will be suffixed
 * with numbers in case of same default name already existing in the supplied names e.g. Default Name 01
 * @param names - array of strings
 * @param defaultName - default name that will be used to determine and generate next name value
 */

export const generateNextDefaultName = (names: string[], defaultName: string): string => {
  let suffix = '';
  // Matches passed defaultName and optionally a suffix
  const regExp = new RegExp(`^${defaultName} *\\d*$`, 'i');
  const defaultNames = names.filter((name) => name.match(regExp));

  if (defaultNames.length) {
    // Maps default name suffixes by converting them to numbers to be sorted afterwards
    const defaultNamesSuffixes = defaultNames.map((name) => {
      // Will match only numbers in name
      return Number(name.match(/\d*$/m)?.[0]);
    });
    const sortedDefaultNames = defaultNamesSuffixes.sort((a, b) => a - b);
    const lastAppliedSuffix = sortedDefaultNames[sortedDefaultNames.length - 1];
    const nextSuffix = (lastAppliedSuffix + 1).toString();
    suffix = nextSuffix.length === 1 ? `0${nextSuffix}` : nextSuffix;
  }

  return `${defaultName}${suffix ? ` ${suffix}` : ''}`;
};
